import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";

const DashboardSkeleton = () => (
  <div className="flex h-screen">
    {/* Sidebar skeleton */}
    <aside className="hidden w-64 flex-col md:flex" style={{ background: "linear-gradient(180deg, hsl(213 56% 18%), hsl(213 56% 26%))" }}>
      <div className="border-b border-white/10 p-6 space-y-2">
        <div className="skeleton h-5 w-32 opacity-30" />
        <div className="skeleton h-3 w-24 opacity-20" />
      </div>
      <nav className="flex-1 p-4 space-y-2">
        {[1, 2, 3].map(i => (
          <div key={i} className="skeleton h-9 w-full opacity-20" />
        ))}
      </nav>
    </aside>

    {/* Main content skeleton */}
    <div className="flex flex-1 flex-col">
      <div className="border-b bg-card h-14 md:hidden" />
      <main className="flex-1 p-4 md:p-8 space-y-6" style={{ background: "linear-gradient(180deg, hsl(213 30% 97%) 0%, hsl(213 20% 94%) 100%)" }}>
        {/* Hero skeleton */}
        <div className="skeleton h-32 w-full rounded-2xl" />
        {/* Cards skeleton */}
        <div className="grid gap-6 lg:grid-cols-2">
          <div className="skeleton h-64 w-full rounded-2xl" />
          <div className="skeleton h-64 w-full rounded-2xl" />
        </div>
      </main>
    </div>
  </div>
);

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
}

const ProtectedRoute = ({ children, allowedRoles }: ProtectedRouteProps) => {
  const { user, role, loading } = useAuth();

  if (loading) return <DashboardSkeleton />;

  if (!user) return <Navigate to="/login" replace />;

  if (allowedRoles && role && !allowedRoles.includes(role)) {
    if (role === "student") return <Navigate to="/student" replace />;
    if (role === "growlearn") return <Navigate to="/growlearn" replace />;
    if (role === "admin") return <Navigate to="/admin" replace />;
    if (role === "aca_member") return <Navigate to="/aca" replace />;
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
